import {
  Component,
  OnInit,
} from '@angular/core';

import {
  getSideMenuStatus,
} from 'src/app/angular-wallet-base/store/appSettings';
import { AppState } from 'src/app/angular-wallet-base/store/appState';

import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-order-type',
  templateUrl: './order-type.component.html',
  styleUrls: ['./order-type.component.scss']
})
export class OrderTypeComponent implements OnInit {

  constructor(
    private modal: ModalController,
    protected store: Store<AppState>,

  ) {
    this.store.select(getSideMenuStatus).subscribe(sideMenu => {
      // updare sidebar css variable to match the modal backdrop and position
      if (sideMenu) {
        document.documentElement.style.setProperty('--sidebar-width', '20px');
      } else {
        document.documentElement.style.setProperty('--sidebar-width', '300px');
      }
    });
  }

  ngOnInit() { }

  async selectOrderType(orderType: string) {
    await this.modal.dismiss(orderType);
  }

  closeModal() {
    this.modal.dismiss();
  }

}
